export default "__VITE_ASSET__CX08iap1__"